var map = {
	"./logo-12up.embedded.svg": 527,
	"./logo-90min.embedded.svg": 528,
	"./logo-dbltap.embedded.svg": 529,
	"./logo-ei.embedded.svg": 530,
	"./logo-floor8.embedded.svg": 531,
	"./logo-ftb90.embedded.svg": 532,
	"./logo-german_site.embedded.svg": 533,
	"./logo-ht_media.embedded.svg": 534,
	"./logo-pluralist.embedded.svg": 535
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1270;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/logo\-.*\.embedded\.svg$
// module id = 1270
// module chunks = 30